import DomainParent from '@/domain/parent/DomainParent.js'

export default class User extends DomainParent {
    constructor( userInfo ) {
        super()
        this._id    = userInfo.id
        this._nome  = userInfo.name
    }

    get nome(){
        return this._nome
    }
}



// WEBPACK FOOTER //
// ./src/domain/User.js